export { UiAdvertisingInformerBase } from './lib/UiAdvertisingInformerBase.dynamic';
export type { UiAdvertisingInformerBaseProps } from './lib/UiAdvertisingInformerBase';
